import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Radio,
  Button
} from 'semantic-ui-react'

const CardSettingTimeOperatingRoomUX = (props: any) => {
    return(
      <div
        id="CardSettingTimeOperatingRoomUX-div-0"
        style={{width:"100%"}}>
        <div
          id="CardSettingTimeOperatingRoomUX-div-1"
          style={{padding: "1.3rem 0px 1rem 5rem", color: "#746A6A", fontWeight: "bold", fontSize: "1.2rem", backgroundColor: "#B4E4EF"}}>
          ตั้งค่าเวลาปิด ห้องผ่าตัด
        </div>
        <div
          id="CardSettingTimeOperatingRoomUX-div-2"
          style={{padding: "2rem"}}>
          
          <div
            className="ui form"
            id="CardSettingTimeOperatingRoomUX-div-3">
            
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-4"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-8"
                inline={true}
                width={2}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-12">
                  วันที่
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-23"
                inline={true}
                width={1}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-24"
                  style={{width: "100px"}}>
                  
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-9"
                inline={true}
                width={4}>
                <div
                  id="CardSettingTimeOperatingRoomUX-div-13"
                  style={{width: "100%"}}>
                  {props.DateTextBoxStart}
                </div>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-10"
                inline={true}
                width={1}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-15"
                  style={{width: "100%", textAlign: "center",fontWeight: "normal"}}>
                  ถึง
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-11"
                inline={true}
                width={4}>
                <div
                  id="CardSettingTimeOperatingRoomUX-div-14"
                  style={{width: "100%"}}>
                  {props.DateTextBoxEnd}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-5"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-16"
                inline={true}
                width={2}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-21"
                  style={{margin: 0}}>
                  เวลาปิด
                </label>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-67"
                  style={{color: "red", marginRight: "0.25rem"}}>
                  *
                </label>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-65">
                  :
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-17"
                inline={true}
                width={1}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-25"
                  style={{ fontWeight: "normal"}}>
                  จาก
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-18"
                inline={true}
                width={4}>
                <div
                  id="CardSettingTimeOperatingRoomUX-div-26"
                  style={{width: "100%"}}>
                  {props.TimeTextBoxStart}
                </div>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-19"
                inline={true}
                width={1}>
                <label
                  id="CardSettingTimeOperatingRoomUX-label-28"
                  style={{width: "100%", textAlign: "center",fontWeight: "normal"}}>
                  ถึง
                </label>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-20"
                inline={true}
                width={4}>
                <div
                  id="CardSettingTimeOperatingRoomUX-div-27"
                  style={{width: "100%"}}>
                  {props.TimeTextBoxEnd}
                </div>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-29">
                <Checkbox
                  checked={props.allHour || false}
                  id="CardSettingTimeOperatingRoomUX-Checkbox-30"
                  label="ทั้งวัน"
                  name="all_hour"
                  onChange={props.onChangeValue}
                  style={{fontWeight: "normal"}}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-31"
                inline={true}>
                <Checkbox
                  checked={props.repeat || false}
                  id="CardSettingTimeOperatingRoomUX-Checkbox-66"
                  label="ต้องการซ้ำ"
                  name="repeat"
                  onChange={props.onChangeValue}
                  style={{marginTop: "1rem", fontWeight: "bold", marginBottom: "0.5rem"}}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-7"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-33"
                inline={true}
                width={3}>
                <Radio
                  checked={props.everyday === true}
                  disabled={!props.config?.enabledRepeat}
                  id="CardSettingTimeOperatingRoomUX-Radio-34"
                  label="ทุกวัน"
                  name="everyday"
                  onChange={(e: any, {checked})=> props.onChangeValue(e, {name:"everyday", checked: true})}
                  style={{marginLeft: "2rem"}}>
                </Radio>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-35"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-36"
                inline={true}
                width={3}>
                <Radio
                  checked={props.everyday === false}
                  disabled={!props.config?.enabledRepeat}
                  id="CardSettingTimeOperatingRoomUX-Radio-37"
                  label="ทุกสัปดาห์"
                  onChange={(e: any, {checked})=> props.onChangeValue(e, {name:"everyday", checked: false})}
                  style={{marginLeft: "2rem"}}>
                </Radio>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-38"
                inline={true}>
                <Button
                  className="circular"
                  disabled={props.config?.disabledMonday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-58"
                  onClick={(e)=>props.onChangeValue(e,{value: 0, name: "select_day"})}
                  style={{backgroundColor:  props.selectDay?.includes( 0) ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  จ.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-39">
                <Button
                  className="circular"
                  disabled={props.config?.disabledTuesday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-57"
                  onClick={(e)=>props.onChangeValue(e,{value: 1, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 1) ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  อ.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-40">
                <Button
                  className="circular"
                  disabled={props.config?.disabledWednesday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-52"
                  onClick={(e)=>props.onChangeValue(e,{value: 2, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 2)  ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  พ.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-41">
                <Button
                  className="circular"
                  disabled={props.config?.disabledThursday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-56"
                  onClick={(e)=>props.onChangeValue(e,{value: 3, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 3) ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.25rem 0.75rem"}}>
                  พฤ.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-42">
                <Button
                  className="circular"
                  disabled={props.config?.disabledFriday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-55"
                  onClick={(e)=>props.onChangeValue(e,{value: 4, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 4)  ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  ศ.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-43">
                <Button
                  className="circular"
                  disabled={props.config?.disabledSaturday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-54"
                  onClick={(e)=>props.onChangeValue(e,{value: 5, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 5)  ? "#5DBCD2" : "transparent", border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  ส.
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-44">
                <Button
                  className="circular"
                  disabled={props.config?.disabledSunday || false}
                  id="CardSettingTimeOperatingRoomUX-Button-53"
                  onClick={(e)=>props.onChangeValue(e,{value: 6, name: "select_day"})}
                  style={{backgroundColor: props.selectDay?.includes( 6)  ? "#5DBCD2" : "transparent",border: "1px solid #746A6A", height: "2.5rem", width: "2.5rem", padding: "0.5rem 0.5rem 0.75rem"}}>
                  อา.
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingTimeOperatingRoomUX-FormGroup-59"
              inline={true}>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-64"
                inline={true}
                width={12}>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-60"
                inline={true}
                width={2}>
                <Button
                  color="green"
                  disabled={props.config?.disabledSave}
                  fluid={true}
                  id="CardSettingTimeOperatingRoomUX-Button-62"
                  onClick={props.onSave}>
                  ตกลง
                </Button>
              </FormField>
              <FormField
                id="CardSettingTimeOperatingRoomUX-FormField-61"
                inline={true}
                width={2}>
                <Button
                  color="red"
                  fluid={true}
                  id="CardSettingTimeOperatingRoomUX-Button-63"
                  onClick={props.onCancel}>
                  ยกเลิก
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardSettingTimeOperatingRoomUX

export const screenPropsDefault = {}

/* Date Time : Tue Jun 10 2025 23:17:46 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งค่าเวลาปิด ห้องผ่าตัด"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1.3rem 0px 1rem 5rem\", color: \"#746A6A\", fontWeight: \"bold\", fontSize: \"1.2rem\", backgroundColor: \"#B4E4EF\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"2rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-3"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-12"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxStart"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxEnd"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"center\",fontWeight: \"normal\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาปิด"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-21"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100px\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "จาก"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TimeTextBoxStart"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TimeTextBoxEnd"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"center\",fontWeight: \"normal\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Checkbox",
      "parent": 29,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.allHour || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Checkbox-30"
        },
        "label": {
          "type": "value",
          "value": "ทั้งวัน"
        },
        "name": {
          "type": "value",
          "value": "all_hour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Radio",
      "parent": 33,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.everyday === true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.config?.enabledRepeat"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Radio-34"
        },
        "label": {
          "type": "value",
          "value": "ทุกวัน"
        },
        "name": {
          "type": "value",
          "value": "everyday"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, {checked})=> props.onChangeValue(e, {name:\"everyday\", checked: true})"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"2rem\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Radio",
      "parent": 36,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.everyday === false"
        },
        "disabled": {
          "type": "code",
          "value": "!props.config?.enabledRepeat"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Radio-37"
        },
        "label": {
          "type": "value",
          "value": "ทุกสัปดาห์"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, {checked})=> props.onChangeValue(e, {name:\"everyday\", checked: false})"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"2rem\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Button",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "พ."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledWednesday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-52"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 2, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 2)  ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Button",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "อา."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledSunday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-53"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 6, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 6)  ? \"#5DBCD2\" : \"transparent\",border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ส."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledSaturday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-54"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 5, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 5)  ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Button",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "ศ."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledFriday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-55"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 4, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 4)  ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Button",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "พฤ."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledThursday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-56"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 3, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 3) ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.25rem 0.75rem\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Button",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "อ."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledTuesday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-57"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 1, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: props.selectDay?.includes( 1) ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Button",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "จ."
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledMonday || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-58"
        },
        "onClick": {
          "type": "code",
          "value": "(e)=>props.onChangeValue(e,{value: 0, name: \"select_day\"})"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:  props.selectDay?.includes( 0) ? \"#5DBCD2\" : \"transparent\", border: \"1px solid #746A6A\", height: \"2.5rem\", width: \"2.5rem\", padding: \"0.5rem 0.5rem 0.75rem\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormGroup-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Button",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "ตกลง"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledSave"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-62"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Button",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Button-63"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ":"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-65"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.repeat || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-Checkbox-66"
        },
        "label": {
          "type": "value",
          "value": "ต้องการซ้ำ"
        },
        "name": {
          "type": "value",
          "value": "repeat"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", fontWeight: \"bold\", marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingTimeOperatingRoomUX-label-67"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", marginRight: \"0.25rem\"}"
        }
      },
      "seq": 65,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSettingTimeOperatingRoomUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
